module.exports = __webpack_public_path__ + "img/02.d34a8569.png";